export default __webpack_public_path__ + "static/media/biscuits.6c18d2d9.svg";